import { Result } from '../store/jobs'

interface StoryPreviewProps {
  result: Result
}

export default function StoryPreview({ result }: StoryPreviewProps) {
  return (
    <div className="w-full h-full bg-black flex items-center justify-center">
      {result.media_url ? (
        result.media_type === 'video' ? (
          <video
            src={result.media_url}
            className="w-full h-full object-contain"
            controls={false}
            muted
            loop
            autoPlay
          />
        ) : (
          <img
            src={result.thumbnail_url || result.media_url}
            alt={result.caption}
            className="w-full h-full object-contain"
          />
        )
      ) : (
        <div className="text-gray-400 text-sm text-center p-4">
          <div className="mb-2">
            {result.media_type === 'video' ? 'Video' : 'Image'}
          </div>
          <div className="text-xs text-gray-500">
            Processing...
          </div>
        </div>
      )}
    </div>
  )
}
